<template>
  <van-overlay show z-index="1000">
    <div class="overlay-wrapper" @click.stop>
      <div class="block rounded-medium">
        <div>
          <img class="mr-1" src="/mobile/img/weixin-icon.png" alt="" width="16" />
          <span class="text-medium text-theme-black-650 align-bottom">{{ text }}</span>
        </div>
        <div class="text-center mt-4">
          <qr :url="url" />
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import Qr from './c/Qr'
import { OAUTH_INFO_API_URL } from 'dygc'

export default {
  name: 'OverlayTip',
  components: { Qr },
  props: {
    text: String
  },
  data() {
    const origin = window.origin
    return {
      url: `${origin}${OAUTH_INFO_API_URL}?returnUrl=${encodeURIComponent(`${origin}/mobile${location.search}`)}`
    }
  }
}
</script>
